import { EventDataParametersType } from '../../../types'

import config from '../../../config'
import { parseUtmParameters } from '../../../utils/parseUtmParams'
import { DEFAULT_BRAND_ID, DEFAULT_CATEGORY, DEFAULT_LOCALE, PLATFORM_ID } from '../constants'
import { getDeviceId, getDeviceType, getUuid } from '../utils'

import { getSystemEventParameters } from './getSystemEventParameters'

let isUtmParametersParsedOnce = false

export const getEventData = async ({
  category = DEFAULT_CATEGORY,
  name,
  parameters = {},
  value,
  ...parameters_
}: EventDataParametersType) => {
  const {
    apiDomain = '',
    brandId = DEFAULT_BRAND_ID,
    platformId = PLATFORM_ID,
    systemEventsNames = [],
    apiKey,
    locale = DEFAULT_LOCALE,
    userAgent,
    appVersion,
    countryId,
  } = await config.get()

  const deviceId = await getDeviceId(apiKey)
  const systemEventParameters = getSystemEventParameters(systemEventsNames, name, userAgent)
  const device = getDeviceType(userAgent)

  let parsedUtmParameters = {}

  // Track UTM only once time
  if (!isUtmParametersParsedOnce) {
    parsedUtmParameters = parseUtmParameters(window.location.href)
    isUtmParametersParsedOnce = true
  }

  return {
    apiDomain,
    brandId,
    category,
    name,
    value,
    app_version: appVersion,
    client_time: Date.now(),
    device_id: deviceId,
    parameters: {
      device,
      locale,
      country_id: countryId,
      ...parameters,
      ...systemEventParameters,
      ...parsedUtmParameters,
    },
    platform_id: platformId,
    uuid: getUuid(),
    ...parameters_,
  }
}
